
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/local/[...place]",
      function () {
        return require("private-next-pages/local/[...place].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/local/[...place]"])
      });
    }
  